import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-secondary text-white/80 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img
              src="https://customer-assets.emergentagent.com/job_hire-showcase/artifacts/tllvl69e_IMG_0034.PNG"
              alt="MRL Plant Hire"
              className="h-14 w-14 object-contain"
            />
            <div className="leading-tight">
              <div className="font-heading uppercase text-base tracking-tight text-white">
                MRL Plant Hire
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-white/60">
                Warragamba · NSW
              </div>
            </div>
          </div>
          <p className="text-sm text-white/70 max-w-sm">
            Reliable plant hire across Western Sydney and the Blue Mountains.
            Owner-operated, fully insured, properly maintained gear.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-orange-400 font-heading mb-3">
            Explore
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="#equipment" className="hover:text-orange-400">Equipment</a></li>
            <li><a href="#why-us" className="hover:text-orange-400">Why Us</a></li>
            <li><a href="#about" className="hover:text-orange-400">About</a></li>
            <li><a href="#contact" className="hover:text-orange-400">Contact</a></li>
            <li><Link to="/admin" className="hover:text-orange-400" data-testid="footer-admin-link">Inquiries (admin)</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-orange-400 font-heading mb-3">
            Contact
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="mailto:MrlPlantHire@gmail.com" className="hover:text-orange-400">MrlPlantHire@gmail.com</a></li>
            <li><a href="tel:+61475591917" className="hover:text-orange-400">0475 591 917</a></li>
            <li><a href="tel:+61418312577" className="hover:text-orange-400">0418 312 577</a></li>
            <li>Warragamba, NSW 2752</li>
            <li>Mon–Sat 6:30am–6:00pm</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-white/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p>© {new Date().getFullYear()} MRL Plant Hire. All rights reserved.</p>
          <p className="font-heading uppercase tracking-[0.2em]">ABN · Local · Insured</p>
        </div>
      </div>
    </footer>
  );
}
